import { useQuery } from '@tanstack/react-query';

import { fetchMovements } from './warehouseApi.js';

// The dashboard's recent-movements feed and (later) the per-item history tab
// both ride this hook. Mutations in useItems/useTrips invalidate the
// ['warehouse','movements'] key hierarchically so the feed refreshes on
// put-away / move / load / depart without polling.
export function useMovements(params = {}) {
  return useQuery({
    queryKey: ['warehouse', 'movements', params],
    queryFn: () => fetchMovements(params),
    staleTime: 30_000,
  });
}
